// extracted by mini-css-extract-plugin
export default {"resultsTablesWrapper":"styles_resultsTablesWrapper__4pi2p"};